import * as React from 'react';

const PointerEventsContext = React.createContext<boolean>('PointerEvent' in window);
PointerEventsContext.displayName = 'PointerEventsContext';

/** Context used to detect and/or override when we should use pointer events instead of mouse events. */
export const PointerEventsProvider = PointerEventsContext.Provider;

/** Return true when we can use pointer events. */
export function usePointerEvents() {
    return React.useContext(PointerEventsContext);
}
